import { StringReplacePipe } from '../../_helpers/_pipes/string-replace.pipe';
import { MapfreButtonComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule , TitleCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, HostListener, Input, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';
import { FormControl, FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { TitleCaseHyphenatedNamePipe } from '@helpers/_pipes/titlecase-hyphenated-name.pipe';
import { ActionType } from '@models/widget/action-type.enum';
import { IdCardService } from '@services/id-card.service';
import{ NavigationService } from '@services/navigation.service';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, StringReplacePipe],
  selector: 'app-id-cards',
  templateUrl: './id-cards.component.html',
  providers: [TitleCaseHyphenatedNamePipe, TitleCasePipe]
})
export class IdCardsComponent implements OnInit {

  @Input() policies: any;
  @Input() isPolicyExists = false;
  @Input() policyId: string;
  @Input() displayIDCardHeader = false;
  @Input() setMarginTop = 16;
  @Input() navFrom = '';
  @Input() index: any;
  policy: any;
  name: string;
  idCardForm: FormGroup;
  vehicles: any;
  policyMap: any;
  selectedVehicles: [];
  policySelected = false;
  isAllItemsSelected = false;
  currentPolicy: any = {};
  selectionOpenned = false;
  
  @HostListener('document:click', ['$event'])
  public onClick(event) {
    if(!event.target.closest('.view-id-card') && !event.target.closest('.download-btn')) {
      if(!event.target.closest('.ng-select')) {
        this.policies.map(policy => policy['isOpen'] = false);
        this.currentPolicy['isOpen'] = false;
        this.onSelectionClose();
      }        
      if(!event.target.closest('.ng-dropdown-panel') && this.selectionOpenned && this.navFrom === 'dashboard') {
        this.selectionOpenned = false;
        this.currentPolicy['isOpen'] = false;
        this.onSelectionClose();
      }
    }    
  }
  
  constructor(
    private idCardService: IdCardService,
    private titleCase: TitleCaseHyphenatedNamePipe,
    private titleCasePipe: TitleCasePipe, private navService: NavigationService
  ) { }

  ngOnInit(): void {
    this.navService.saveCurrentAction(ActionType.GetIdCards);
    this.navService.viewActionHistory();
    this.idCardForm = new FormGroup({
      selectedPolicy: new FormControl(''),
      selectedItems: new FormControl(''),
    });
    this.getChoosePolicyMap();
    if(this.isPolicyExists && this.policies.length ) {
      this.getVehicleList(this.policyId, false);
    } else {
      if(this.policies.length === 1) {
        this.getVehicleList(this.policies[0].policynumber.policyNumber, false);
      }
    }
  }
  getChoosePolicyMap(): void {
    this.policyMap = this.policies.map(p => {
        const modifiedPolicyName = ((p.policyType ==='HOME') ? "Property" : this.titleCasePipe.transform(p.policyType)); 
        return {...p,disabled: false, name: `${modifiedPolicyName} - ${p.policynumber.policyNumber}`}
     });
     this.policyMap.unshift({name: 'Select'});
     this.idCardForm.controls.selectedPolicy.setValue(this.policyMap[0].name);
      this.policyMap[0].disabled = true;
  }
  getLastFourDigits(vehicleIdentificationNumber:string): string {
    return ' — VIN: #' + vehicleIdentificationNumber.slice(-4);
  }
  getSlectedVehicles() {
    const selectedListOfVehicles = [];
    this.selectedVehicles.forEach((vehicle: any ) => {
      selectedListOfVehicles.push({ 
        vehicleIdentificationNumber: vehicle.vehicleIdentificationNumber,
        vehicleMake: vehicle.vehicleMake,
        yearOfManufacture: vehicle.yearOfManufacture
      })
    })
    return selectedListOfVehicles;
  }
  getTitleCaseName(name) {
    return this.titleCase.transform(name);
  }
  getVehicleList(policyNumber, isOnPolicySelect) {
    this.policies.map(policy => policy['isOpen'] = false);
    this.policy = this.policies.find(policy => policy.policynumber.policyNumber === policyNumber);
    if (this.policy) {
      this.policy.vehicle.forEach(vehicleItem => {
        vehicleItem.name = this.getTitleCaseName(vehicleItem.vehicle) + this.getLastFourDigits(vehicleItem.vehicleIdentificationNumber.Id);
      })
      this.vehicles = this.policy.vehicle.filter(veh => veh.vehicleType !== 'utility_trailer');
      // Required to set it to form for single vehicle or no vehicle when user not selected the vehicle manually
      if(this.vehicles && this.vehicles.length <= 1 && !isOnPolicySelect) {
        this.idCardForm.get('selectedItems').setValue(this.vehicles);
      }
    }
  }
  onPOlicySelect(val) {
    void val;
    this.clearAll();
     if(this.idCardForm.controls.selectedPolicy.value === 'Select') {
       this.vehicles = [];
    //  }
    // if(val === 'Select') {
    //   this.vehicles = [];
    } else { 
      this.policySelected = true;
      const policyNumber = this.idCardForm.controls.selectedPolicy.value.split(" ")[2];
      this.getVehicleList(policyNumber, true);
    }
  }
  selectAll() {
    if(this.isAllItemsSelected) {
      this.isAllItemsSelected = false;
      this.clearAll();
    } else {
      this.isAllItemsSelected = true;
      this.idCardForm.get('selectedItems').setValue(this.vehicles);
    } 
  }
  clearAll() {
    this.idCardForm.get('selectedItems').setValue([]);
  }
  viewIdCard() {
    this.selectedVehicles = this.idCardForm.value.selectedItems;
    this.idCardService.getIdCard(this.policy, 'view', this.policy.policynumber.policyNumber, this.getSlectedVehicles());
  }

  downloadIdCard() {
    this.selectedVehicles = this.idCardForm.value.selectedItems;
    this.idCardService.getIdCard(this.policy, 'download', this.policy.policynumber.policyNumber, this.getSlectedVehicles());
  }
  getClientHight() {
    let selector;
    if(this.index) {
      selector = `.index-${this.index} .ng-dropdown-panel`;
    } else {
      selector = '.ng-dropdown-panel';
    }
    const ele = document.querySelector(selector)
    return ele ? ele.clientHeight : 0;
  }
  onSelectOpen(policyId) {
    if(this.navFrom === 'dashboard') {
      this.currentPolicy = this.policies.find(policy => policy.policynumber.policyNumber === policyId);      
    } else {
      this.currentPolicy = { ...this.policy };
    }
    this.currentPolicy['isOpen'] = true;  
    if(this.navFrom !== 'dashboard') {
      this.setMarginTop = this.vehicles && this.vehicles.length === 1 ? 24 : 32;      
    }
    setTimeout(() => {
      this.currentPolicy['heightOfSelctOptions'] = ( this.getClientHight() + this.setMarginTop) + 'px';
      this.selectionOpenned = true;
    }, 100);
  }
  onSelectionClose() {
    if(this.navFrom === 'dashboard') {
      this.currentPolicy['heightOfSelctOptions'] = '16px';
    } else {
      this.currentPolicy['heightOfSelctOptions'] = this.vehicles && this.vehicles.length === 1 ? '24px': '32px';
    }
  }
}
